import * as React from 'react';

import {
  humanReadableShortPricingUnit,
  NumberField,
  Unit,
  cn,
} from '@rematter/ui-web';

export interface QuantityFieldCellProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  minValue?: number;
  pricingUnit?: Unit;
  className?: string;
  errorMessage?: string;
  isInvalid?: boolean;
}

export const QuantityFieldCell: React.FC<QuantityFieldCellProps> = ({
  value,
  onChange,
  disabled = false,
  minValue = 0,
  className,
  pricingUnit,
  errorMessage,
  isInvalid,
}) => {
  const massUnitAbbreviation = React.useMemo(
    () => humanReadableShortPricingUnit(pricingUnit),
    [pricingUnit],
  );

  return (
    <NumberField
      value={value}
      onChange={onChange}
      minValue={minValue}
      isDisabled={disabled}
      className={cn('@QuantityFieldCell', className)}
      showSteppers={false}
      suffix={massUnitAbbreviation}
      errorMessage={errorMessage}
      isInvalid={isInvalid}
    />
  );
};
